<template>
    <button class="btn btn-link px-1" title="Submitted by Mail" @click="$emit('click')">
        <span class="fa-stack fa-lg mailed-stack">
            <i class="fas fa-envelope-open-text fa-stack-2x mailed-icon"></i>
            <i v-if="mailed || received" :class="[received ? 'fas' : 'far', 'fa-check-circle fa-stack-1x text-success mailed-badge']"></i>
        </span>
    </button>    
</template>

<script>
export default {
    props: {
        mailed: Boolean,
        received: Boolean
    }
}
</script>

<style scoped>
    .mailed-stack {
        width: 1em;
        height: 1em;
        line-height: 1em;
        vertical-align: 0%;
    }

    .mailed-icon {
        font-size: 1em;
    }
    
    .mailed-badge {
        font-size: .6em;
        position: relative;
        top: -12px;
        left: 10px;
    }
</style>